import { Amplify } from 'aws-amplify';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - amplify_outputs.json is generated during deployment
import outputs from '../../amplify_outputs.json';

/**
 * Configure AWS Amplify with backend resources
 * This function should be called once at app initialization
 *
 * CRITICAL FIX: Explicitly map aws_region to region for Amplify v6 compatibility
 */
export function configureAmplify() {
  // CRITICAL FIX: Transform config to set region AND preserve model_introspection
  // Amplify v6 expects 'region' but amplify_outputs.json has 'aws_region'
  // Also need to preserve model_introspection for generateClient<Schema>()

  // Type assertion needed because AWS Amplify types don't include region property
  // but it's required at runtime for proper configuration
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const transformedConfig: any = {
    Auth: {
      Cognito: {
        userPoolId: outputs.auth.user_pool_id,
        userPoolClientId: outputs.auth.user_pool_client_id,
        identityPoolId: outputs.auth.identity_pool_id,
        region: outputs.auth.aws_region, // CRITICAL: Explicit region mapping
        loginWith: outputs.auth.oauth ? {
          oauth: {
            domain: outputs.auth.oauth.domain,
            scopes: outputs.auth.oauth.scopes,
            redirectSignIn: outputs.auth.oauth.redirect_sign_in_uri,
            redirectSignOut: outputs.auth.oauth.redirect_sign_out_uri,
            responseType: outputs.auth.oauth.response_type as 'code' | 'token',
          }
        } : undefined,
      }
    },
    API: outputs.data ? {
      GraphQL: {
        endpoint: outputs.data.url,
        region: outputs.data.aws_region,
        defaultAuthMode: outputs.data.default_authorization_type as 'apiKey' | 'userPool' | 'iam' | 'oidc' | 'lambda',
        apiKey: outputs.data.api_key,
        // CRITICAL: Preserve model_introspection for generateClient<Schema>()
        modelIntrospection: outputs.data.model_introspection,
      }
    } : undefined,
    Storage: outputs.storage ? {
      S3: {
        bucket: outputs.storage.bucket_name,
        region: outputs.storage.aws_region,
      }
    } : undefined,
  };

  // Configure Amplify with transformed config
  Amplify.configure(transformedConfig);

  // CRITICAL: Verify region is set correctly
  const finalConfig = Amplify.getConfig();
  // Type assertion needed because AWS Amplify types don't expose region property
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cognitoConfig = finalConfig.Auth?.Cognito as any;
  if (!cognitoConfig?.region) {
    throw new Error('Amplify configuration failed: Region is undefined');
  }
}

/**
 * Get current Amplify configuration
 * Useful for debugging and verification
 */
export function getAmplifyConfig() {
  return Amplify.getConfig();
}
